import { Channel, ChannelType } from 'api/ChannelsAPI';
import { MessageType } from 'api/MessageTypeAPI';

export type ChannelsByMessageMedium = {
  [channelMessageMedium: string]: Channel[];
};

export type ChannelBinding = {
  id: string;
  num: string;
  option: string;
};

export enum BindingTypes {
  DEFAULT = 'default',
  CUSTOM = 'custom',
}

export type UpdateChannelFormState = {
  bindingType: BindingTypes;
  channelBindings: ChannelBinding[];
  channelName: string;
};

export type MessageTypesByChannelId = { [key: string]: MessageType[] };

export type ChannelFormState = {
  bindingType: BindingTypes;
  channelBindings: ChannelBinding[];
  channelName: string;
  channelType: ChannelType;
};

export type MessageTypeFormState = {
  messageTypeName: string;
  subscriptionPolicy: string;
};

export type BindingError = { num: { message: string }; option: { message: string } } | undefined;
